const de = {
  nav: {
    services: 'Services',
    amazonPPC: 'Amazon PPC',
    produktbilder: 'Produktbilder',
    amazonSEO: 'Amazon SEO',
    designPortfolio: 'Design Portfolio',
    customerSuccess: 'Erfolge unserer Kunden',
    contact: 'Kontakt',
  },

  hero: {
    tagline: 'Amazon Experten aus Deutschland',
    title: 'Skaliere dein Amazon PPC in nur 90 Tagen –',
    titleHighlight: 'mit bis zu 80 % mehr Profit',
    titleEnd: '!',
    bullets: [
      'Ohne Bindung interner Ressourcen!',
      'Ca. 20 Stunden Zeitersparnis pro Woche für Dein Team',
      'Meist 2-4x ROI auf unsere Betreuung – gemessen am Seller-Profit',
    ],
    ratingScore: '5,0',
    videoCaption: 'Kundenfeedback von',
    videoCaptionName: 'Flavio Simonetti',
    ctaTitle: 'Kostenlose Accountanalyse',
    ctaSub: 'Wir analysieren dein Amazon-Account und zeigen dir, wie du mehr Umsatz generierst.',
    bulletsCta: '» Potenzial prüfen',
    advisorAlt: 'Berater',
    minimize: 'Minimieren',
    free: 'Kostenlos',
    play: 'Play',
    pause: 'Pause',
  },

  referencesBanner: {
    title: 'Auswahl unserer Kunden',
  },

  servicesBanner: {
    label: '15+ Jahre Erfahrung',
    title: 'Full-Service',
    titleHighlight: 'für Amazon Seller',
    subtitle: 'Als ehemalige Amazon Händler wissen wir, was es braucht um auf Amazon erfolgreich zu sein. Deshalb bieten wir dir nicht nur einzelne Services – sondern ein',
    subtitleHighlight: 'Komplettpaket aus Performance, Design und Strategie',
    card1Pill: 'Amazon PPC Management',
    card1Title: 'Profit',
    card1TitleLight: 'statt nur Traffic',
    card1Desc: 'Wir betreuen deinen Account wie unseren eigenen – mit Fokus auf',
    card1DescBold: 'echten Profit, nicht nur ACOS',
    card1DescEnd: '. Seit 2017 eigene Amazon Brands, manuelle Optimierung, Geschäftsführer-Betreuung.',
    card2Pill: 'Creative Flatrate',
    card2TitleLight: 'Hunderte Listings.',
    card2Title: 'Eine Flatrate.',
    card2Desc: 'Creative Flatrate für größere Brands mit skalierbarem Bedarf. Wir erstellen anhand von echten Rezensionen und Kundenfeedback',
    card2DescBold: 'das perfekte Grafikdesign nach Amazon-Compliance',
    card2DescEnd: ' und bauen Pain Points aus Reviews direkt ins Bild – buchbar als Abo für langfristiges Wachstum.',
    card3Pill: 'Amazon SEO & Strategie',
    card3TitleLight: 'Von Strategie bis',
    card3Title: 'Launch',
    card3Desc: 'Individuelle Amazon Strategie für nachhaltiges Wachstum. Wir kombinieren SEO + PPC + Conversion und halten dich compliant mit Amazon Richtlinien 2025 –',
    card3DescBold: 'maximaler Hebel ohne Black Hat',
    card3DescEnd: '.',
    cta: 'Kostenlose Accountanalyse',
  },

  ppcSection: {
    label: 'Amazon PPC',
    title: 'Amazon',
    titleHighlight: 'PPC',
    tagline: 'Direkte Betreuung. Echter Profit.',
    description: 'Wir arbeiten direkt an deinem Amazon PPC. Mit eigener',
    descriptionBold: 'Seller-Erfahrung seit 2017',
    descriptionEnd: ', manueller Optimierung und direkter Geschäftsführer-Betreuung sorgen wir für nachhaltiges Wachstum und echten Profit – keine One-Fits-All-Automatisierung.',
    feature1Title: 'Seller-Mindset',
    feature1Text: 'Dein Account wie unser eigener – wir denken wie Seller.',
    feature2Title: 'Eigene Seller-Erfahrung',
    feature2Text: 'Eigene Amazon Brands seit 2017 – wir kennen den Seller-Alltag.',
    feature3Title: 'Direkte Betreuung',
    feature3Text: 'Geschäftsführer-Betreuung, WhatsApp & regelmäßige Calls.',
    feature4Title: 'Keine Automatisierung',
    feature4Text: 'Manuelle Arbeit im Account, keine Tool-Automatisierung.',
    feature5Title: 'Immer am Zahn der Zeit',
    feature5Text: 'Neue PPC-Features sofort im Einsatz: Top of Search Placement Boost, Dayparting & mehr.',
    feature6Title: 'Fokus auf Profit',
    feature6Text: 'Gesamtumsatz & Profit statt nur ACOS-Optimierung.',
    cta: 'Kostenlose Accountanalyse',
    stat1Label: 'Eigene Brands seit',
    stat1Value: '2017',
    stat2Label: 'Verwalteter Werbeumsatz',
    stat2Value: '250 Mio+',
    stat3Label: 'Fokus auf',
    stat3Value: 'Profit',
  },

  productImages: {
    label: 'Creative Flatrate',
    title: 'Amazon',
    titleHighlight: 'Produktbilder',
    tagline: 'Creative Flatrate für größere Brands.',
    description: 'Für Brands mit einer Vielzahl an Produkten und skalierbarem Bedarf. Wir erstellen anhand von echten Rezensionen und Kundenfeedback das perfekte Grafikdesign nach Amazon-Richtlinien und bauen die wichtigsten Pain Points direkt in die Bilder ein – buchbar als Flatrate/Abo für langfristiges Wachstum.',
    highlightsLabel: 'Wir kombinieren:',
    highlight1: 'Rendering + Amazon Compliance',
    highlight2: 'Gebaut aus echten Rezensionen',
    highlight3: 'Conversion-optimierte Infografiken',
    highlight4: 'Buchbar als Flatrate / Abo',
    sliderHint: 'Slider bewegen zum Vergleichen',
    beforeLabel: 'Vorher',
    afterLabel: 'Nachher',
    cta: 'Jetzt Flatrate anfragen',
  },

  portfolioTeaser: {
    label: 'Design Portfolio',
    title: '100+ Projekte.',
    titleHighlight: 'Unser Design Portfolio',
    subtitle: 'Entdecke unsere Arbeiten – von Main Images bis A+ Content. Finde deine Branche und lass dich inspirieren. Wir sind für dich da, um deine Ideen zu realisieren.',
    ctaLink: 'Zum Portfolio',
    viewAll: 'Alle Designs ansehen',
  },

  seoSection: {
    label: 'Amazon SEO',
    title: 'Amazon',
    titleHighlight: 'SEO',
    tagline: 'Ab Tag eins perfekt positioniert.',
    description: 'Viele Seller optimieren nur auf die größten Keywords – das ist ein Fehler. Wir kombinieren SEO-Struktur, PPC-Daten und Conversion-Optimierung, um das Maximum aus deinem Listing rauszuholen. Dabei halten wir dich immer compliant mit den aktuellen Amazon Richtlinien 2025.',
    feature1Title: 'Mehr als High-Volume Keywords',
    feature1Desc: 'Die meisten Seller optimieren nur auf die größten Keywords – und kämpfen gegen maximale Konkurrenz. Wir finden gezielt Keywords mit weniger Wettbewerb, die deutlich leichter zu ranken sind und trotzdem relevanten Traffic bringen.',
    feature2Title: 'SEO + PPC + Conversion',
    feature2Desc: 'Ranking entsteht nicht durch SEO allein. Wir kombinieren SEO-Struktur mit PPC-Daten, optimieren die Klickrate (CTR) und steigern die Conversion Rate – für ein Listing, das auf allen Ebenen performt.',
    feature3Title: 'Amazon Richtlinien 2025',
    feature3Desc: 'Viele Seller riskieren Ranking-Strafen, weil sie aktuelle Listing-Richtlinien nicht korrekt umsetzen. Wir achten auf Details wie keine Emojis, keine unnötige Großschreibung, keine Sonderzeichen-Tricks und keine Keyword-Dopplungen.',
    feature4Title: 'Maximaler Hebel ohne Risiko',
    feature4Desc: 'Wir holen das Maximum aus deinem Listing raus – sauber, nachhaltig und ohne Black-Hat-Methoden. So rankst du langfristig stabil, ohne spätere Probleme mit Amazon zu riskieren.',
    cta: 'Jetzt SEO-Analyse anfragen',
  },

  linkedInPreview: {
    label: 'Folge uns',
    title: 'Verbinde dich mit uns auf',
    titleHighlight: 'LinkedIn',
    subtitle: 'Insights, Case Studies und News aus der Amazon-Welt.',
    profileName: 'Wolfgang Niedecken',
    profileCompany: '(Fox Performance)',
    profileRole: 'Amazon PPC | +250 Mio € betreuter Werbeumsatz seit 2018 | Umsatzsteigerung & Zeitersparnis durch datengetriebenes Amazon Advertising | Mastermind Host',
    location: 'Weinheim, Baden-Württemberg, Deutschland',
    followers: '12.024',
    followersLabel: 'Follower',
    connections: '500+',
    connectionsLabel: 'Kontakte',
    followBtn: 'Folgen',
    messageBtn: 'Nachricht senden',
    feedTitle: 'Aktuelle Beiträge',
    post1Content: 'Neue Case Study: +127% Umsatzsteigerung für unseren Kunden in nur 3 Monaten durch optimierte Amazon PPC Strategien.',
    post1Date: 'vor 2 Tagen',
    post2Content: 'Amazon Advertising Update 2026: Was bedeuten die neuen Sponsored Brands Features für deine Marke?',
    post2Date: 'vor 5 Tagen',
    seeAll: 'Alle Beiträge ansehen',
  },

  statsSection: {
    label: 'Messbare Ergebnisse',
    title: 'Zahlen, die für sich sprechen',
    stat1Value: '+127%',
    stat1Label: 'Umsatzsteigerung',
    stat1Desc: 'Durchschnittlich bei unseren Kunden im ersten Jahr',
    stat2Value: '-34%',
    stat2Label: 'ACoS Reduktion',
    stat2Desc: 'Bei gleichzeitiger Steigerung der Sichtbarkeit',
    stat3Value: '24h',
    stat3Label: 'Reaktionszeit',
    stat3Desc: 'Maximale Wartezeit auf Account-Optimierungen',
  },

  comparisonSection: {
    label: 'Der Unterschied',
    title: 'Warum Seller zu uns wechseln',
    othersTitle: 'Typische Herausforderungen mit Agenturen',
    others1: 'Wechselnde Ansprechpartner, keiner kennt dein Account',
    others2: 'Monatliche Reports ohne echte Insights',
    others3: 'Hauptsache Budget ausgeben, Profit egal',
    others4: 'Tagelang keine Antwort auf dringende Fragen',
    others5: 'Junior-Mitarbeiter ohne Amazon-Erfahrung',
    others6: 'Lange Vertragslaufzeiten, versteckte Kosten',
    usTitle: 'Fox Performance',
    us1: 'Fester Ansprechpartner',
    us1End: ', der dein Business kennt',
    us2Start: 'Regelmäßige Calls mit',
    us2Bold: 'konkreten Action Items',
    us3Bold: 'Profit-First:',
    us3End: ' Jede Entscheidung muss sich rechnen',
    us4Start: 'Max.',
    us4Bold: '48h Reaktionszeit',
    us4End: ', meistens schneller',
    us5Bold: '15+ Jahre',
    us5End: ' Amazon-Erfahrung im Team',
    us6Start: 'Faire Preise,',
    us6Bold: '6 & 12 Monatsverträge',
  },

  caseStudies: {
    label: 'Case Studies',
    title: 'Echte',
    titleHighlight: 'Ergebnisse',
    subtitle: 'Erfolgsgeschichten unserer Kunden',
    changesTitle: 'Was wurde geändert?',
    moreChanges: 'weitere Maßnahmen',
    clickToEnlarge: 'Klicken zum Vergrößern',
    closeLightbox: 'Close lightbox',
    case1Client: 'Aquaristikwelt24',
    case1Subtitle: 'Pool & Aquarien Zubehör',
    case1Badge: '+457% Wachstum',
    case1Highlight: '98.000€ → 448.324€ Werbe-Umsatz',
    case1Desc: 'Bei Übernahme lagen die besten Monate bei 98.000€. Mit einem optimierten Ziel-ACoS konnten wir den Umsatz auf 448.324€ skalieren – innerhalb der Profitabilitätsziele.',
    case2Client: 'McFilter',
    case2Subtitle: 'Staubsauger Zubehör',
    case2Badge: 'ACoS -69%',
    case2Highlight: '26,64% → 8,17% ACoS bei 5x mehr Umsatz',
    case2Desc: 'Der Account startete mit 74.964€ Werbe-Umsatz bei ineffizienten 26,64% ACoS. Heute: 375.590€ Umsatz bei nur 8,17% ACoS – eine Effizienzsteigerung von 69%.',
    case3Client: 'Supplements-Brand',
    case3Subtitle: 'Vertraulicher Kunde',
    case3Badge: 'Cold Start',
    case3Highlight: '112.628€ Umsatz in 3 Monaten, +45,9% Profit',
    case3Desc: 'Der Kunde hatte zuvor noch nie Amazon Ads geschaltet und war skeptisch gegenüber Agenturen. In einem der kompetitivsten Märkte konnten wir in nur 3 Monaten über 112.000€ Werbe-Umsatz bei 11,94% ACoS erzielen.',
    case4Client: 'Elektronik-Hersteller',
    case4Subtitle: 'Vertraulicher Kunde',
    case4Badge: '+24.543€',
    case4Highlight: '-16.542€ → +8.001€ Gewinn pro Quartal',
    case4Desc: 'Der Account war tief in den roten Zahlen. Innerhalb weniger Monate konnten wir den Turnaround schaffen und konstante Profitabilität herstellen.',
    case5Client: 'Haushaltsgeräte-Brand',
    case5Subtitle: 'Vertraulicher Kunde',
    case5Badge: '+41.625€',
    case5Highlight: '-10.943€ → +30.682€ Gewinn (Jan.-Sept.)',
    case5Desc: 'Komplette Neuausrichtung der PPC-Strategie mit Fokus auf Profitabilität statt reinem Umsatzwachstum.',
    changePortfolio: 'Portfolio-Restrukturierung',
    changeNegativeKW: 'Negatives Keyword Harvesting',
    changeConversion: 'Conversion-basierte Kampagnen',
    changeRetargeting: 'Retargeting-Strategie',
    changeLaunch: 'Produktlaunch-Begleitung',
    changeListing: 'Listing-Optimierung',
    changePortfolioNew: 'Portfolio-Aufbau von Null',
    changeTopPerformer: 'Fokus auf Top-Performer',
  },

  testimonials: {
    title: 'Was unsere',
    titleHighlight: 'Kunden sagen',
    subtitle: 'Erfahre, wie wir Händlern dabei helfen, auf Amazon erfolgreich zu werden',
    readMore: 'Mehr lesen',
    readLess: 'Weniger',
    prevLabel: 'Previous testimonial',
    nextLabel: 'Next testimonial',
    trustCount: '50+',
    trustLabel: 'Zufriedene Kunden',
    trustRating: '5.0',
    trustRatingLabel: 'Durchschnittliche Google Bewertung',
    trustRecommend: '100%',
    trustRecommendLabel: 'Weiterempfehlung',
    testimonial1: 'Seit 2024 vertrauen wir bei der Amazon-Werbung auf die Expertise von Fox Performance. Wolfgang und Michael haben nicht nur unsere Kampagnen optimiert, sondern verstehen als strategische Partner genau, worauf es bei Papierdrachen ankommt. Die Zusammenarbeit ist persönlich, transparent und vor allem erfolgreich. Wir freuen uns auf die weiteren gemeinsamen Jahre!',
    testimonial2: 'Die Zusammenarbeit mit Fox Performance hat nur Vorteile. Hier finde ich keine Agentur vor, die einfach vor sich hinarbeitet und man keine Transparenz bekommt, sondern wir sprechen viele wichtige Dinge direkt mit meinem persönlichen Ansprechpartner ab. Die letzten zwei Produkte, die wir auf Amazon gebracht haben, waren schon nach wenigen Wochen profitabel.',
    testimonial3: 'Mit meiner Marke Green Naturals ist es wichtig, immer das Maximum aus allen Kanälen rauszuholen - gerade in solch kompetitiven Produkt-Nischen. Fox Performance sticht hier mit einer schnellen Kommunikation raus und ist hier eine große Hilfe, die immer zuverlässig ist und weit über den Tellerrand hinausschaut.',
    testimonial4: 'Durch Fox Performance wurden meine Produkte das erste mal so richtig sichtbar auf Amazon. Was raussticht ist definitiv, dass hier vorrangig auf Profit geschaut wird und nicht nur auf Umsatz. Das hat mir von Beginn an ein gutes Gefühl gegeben und ich wurde nicht enttäuscht.',
    testimonial5: 'Mit Fox Performance arbeiten wir seit einigen Jahren zusammen. Sowohl im Bereich Advertising als auch im Bereich Bilder ist die Arbeit top. Man denkt mit, bringt eigene Ideen und Erfahrungen mit ein. So ist es nicht das typische \'Agentur-Kunde-Verhältnis\', sondern ein Miteinander, wie es sein sollte. FOX PERFORMANCE kann ich absolut weiterempfehlen.',
    testimonial6: 'Wolfgang von Fox Performance sieht Amazon PPC durch die Händlerbrille, nur eben mit mehr Expertise. Ganz klare Aussagen, kein klassisches Agentur-Gestammel! Der Mann hat Ahnung wovon er spricht.',
    testimonial7: 'Wolfgang verfügt über ein tiefgehendes Verständnis für datengetriebenes PPC Management und führt sein Team mit klarer Vision und hohem Anspruch. Unter seiner Leitung ist es ihm und seinem Team gelungen, den TACoS-Wert unseres Amazon-Accounts innerhalb weniger Monate signifikant zu senken und damit die Profitabilität unseres Unternehmens deutlich zu steigern. Er legt großen Wert auf transparente Prozesse und einen offenen Austausch. Wer auf der Suche nach einem Partner ist, der nicht nur Expertise liefert, sondern echte Mehrwerte schafft und dabei auf persönliche Betreuung setzt, ist bei Wolfgang und seinem Team von Fox Performance in besten Händen.',
    testimonial8: 'Zuverlässig, schnell, proaktiv. Genau das was man braucht um erfolgreich bei Amazon durchzustarten. Danke an das Fox Performance Team!',
    testimonial9: 'Das große Wissen zum PPC merkt man direkt in den Calls mit Fox Performance und er schafft es trotzdem, die Thematiken verständlich herunterzubrechen. Dabei schonungslos ehrlich und transparent!',
    testimonial10: 'Wir arbeiten inzwischen seit über 4 Jahren mit Wolfgang und Michael zusammen. Die Arbeit mit dem Team von Fox Performance ist immer sehr zielorientiert und auf Augenhöhe. Es geht stetig um die Skalierung und optimale Weiterentwicklung unserer Performance auf Amazon. Super finde ich das sich das Team ständig weiterentwickelt und auf die stetig massiven Änderungen bei Amazon reagiert um ein optimales Ergebnis für seine Kunden zu erzielen. Weiter so!',
    role_kunde: 'Kunde',
    role_fbaSeller: 'FBA Seller',
    role_ceo: 'CEO',
    role_gruender: 'Gründer',
    role_geschaeftsfuehrer: 'Geschäftsführer',
  },

  featuredTestimonials: {
    testimonial1: 'Wolfgang verfügt über ein tiefgehendes Verständnis für datengetriebenes PPC Management und führt sein Team mit klarer Vision und hohem Anspruch. Unter seiner Leitung ist es ihm und seinem Team gelungen, den TACoS-Wert unseres Amazon-Accounts innerhalb weniger Monate signifikant zu senken und damit die Profitabilität unseres Unternehmens deutlich zu steigern.',
    testimonial2: 'Das große Wissen zum PPC merkt man direkt in den Calls mit Fox Performance und er schafft es trotzdem, die Thematiken verständlich herunterzubrechen. Dabei schonungslos ehrlich und transparent!',
    testimonial3: 'Wir arbeiten inzwischen seit über 4 Jahren mit Wolfgang und Michael zusammen. Die Arbeit mit dem Team von Fox Performance ist immer sehr zielorientiert und auf Augenhöhe. Es geht stetig um die Skalierung und optimale Weiterentwicklung unserer Performance auf Amazon.',
    testimonial4: 'Seit 2024 vertrauen wir bei der Amazon-Werbung auf die Expertise von Fox Performance. Wolfgang und Michael haben nicht nur unsere Kampagnen optimiert, sondern verstehen als strategische Partner genau, worauf es bei Papierdrachen ankommt. Die Zusammenarbeit ist persönlich, transparent und vor allem erfolgreich. Wir freuen uns auf die weiteren gemeinsamen Jahre!',
  },

  teamSection: {
    label: 'Warum Fox Performance?',
    title: 'Erreiche den Bestseller Status mit',
    titleHighlight: 'Fox Performance',
    subtitle: 'Lass uns deine Produkte erfolgreich auf Amazon skalieren',
    teamImageAlt: 'Team - Wolfgang Niedecken und Michael Wenger',
    feature1Title: 'Über 15 Jahre Amazon Expertise',
    feature1Subtitle: 'Bewährte Strategien aus tausenden Kampagnen',
    feature1Desc: 'Unser Team vereint jahrelange Erfahrung im Amazon-Ökosystem. Wir haben Produkte in nahezu jeder Kategorie erfolgreich skaliert und kennen die Feinheiten, die den Unterschied zwischen Durchschnitt und Bestseller ausmachen.',
    feature2Title: 'Individuelle Wachstums-Strategien',
    feature2Subtitle: 'Maßgeschneidert für deine Produkte & Ziele',
    feature2Desc: 'Keine Copy-Paste-Lösungen. Wir analysieren deine Produkte, Margen und Konkurrenz, um eine Strategie zu entwickeln, die genau auf dein Business zugeschnitten ist. Von Launch bis Skalierung.',
    feature3Title: 'Persönlicher Ansprechpartner',
    feature3Subtitle: 'Direkter Draht zu deinem Account Manager',
    feature3Desc: 'Du hast einen festen Ansprechpartner, der dein Business kennt. Regelmäßige Calls, transparente Reports und schnelle Reaktionszeiten. Kein Agentur-Chaos, sondern partnerschaftliche Zusammenarbeit.',
    feature4Title: 'Datengetriebene Optimierung',
    feature4Subtitle: 'Entscheidungen basierend auf echten Zahlen',
    feature4Desc: 'Wir treffen keine Bauchentscheidungen. Jede Optimierung basiert auf detaillierten Analysen deiner Performance-Daten. TACoS, ACoS, CVR – wir haben alle KPIs im Blick und optimieren kontinuierlich.',
    cta: 'Kostenlose Accountanalyse',
  },

  faq: {
    label: 'FAQ',
    title: 'Häufig gestellte',
    titleHighlight: 'Fragen',
    q1: 'Was soll Werbung denn groß noch bringen? Ich kann mir nicht vorstellen, dass es so ein großer Mehrwert ist.',
    a1: 'Jeder von uns hat einen anderen Sprachgebrauch. Nehmen wir das Wort Brötchen. Hier haben wir abhängig vom Bundesland und Dialekt – Brötchen, Semmel, Brot, Backen, Teigzapfen, etc. – Und dasselbe ist bei Artikel aufzufinden. Bei der Werbung geht es darum Ihren Artikel unter den Wörtern zu präsentieren unter denen Ihre potenziellen Kunden suchen. Hier gilt, mehr Sichtbarkeit ist gleich mehr Umsatz.',
    q2: 'Wir machen das inhouse und es läuft ganz gut. Warum sollte ich jemand externen da mit einbeziehen?',
    a2: 'Es ist sehr gut, dass Sie die Wichtigkeit des Themas behandelt haben. Hier sind Sie bereits vielen Verkäufer weit voraus. Mit den meisten Unternehmen, mit denen ich rede, welche das Thema inhouse behandeln, geht es nicht darum die Basics zu erklären, sondern eher die Struktur hinter der Werbung, Zusammenspiel der Werbeformate, neue Möglichkeiten im Bereich der Werbung, Optimierungsroutinen und auch die richtigen Strategien für jeden Artikel. Hier reden wir über Punkte, für die es keine IHK Ausbildung gibt und würde alles perfekt laufen, wären Sie meinem Analysten nicht aufgefallen und wir würden jetzt nicht miteinander reden. Ob ich ihnen aber tatsächlich helfen kann, müssen die Daten entscheiden.',
    q3: 'Wir haben so eine geringe Marge auf den Artikel, dass es für uns keinen Sinn ergibt, jetzt auch noch Werbung zu schalten.',
    a3: 'Genau hier ist umso wichtiger, seine Werbung perfekt ausgerichtet zu haben. Es gibt für jeden Artikel die richtige Strategie und wir müssen nur schauen, wie groß das Potenzial bei Ihren Artikel noch ist.',
    q4: 'Ich habe schlechte Erfahrungen mit anderen Agenturen gemacht und wir wollen es jetzt selbst machen.',
    a4: 'Dann ist es doch super das wir miteinander sprechen. Lassen Sie sich einfach vom Gegenteil überzeugen und lassen Sie uns an das Thema ganz transparent und datenbasiert herangehen. Wenn ich nach meiner Analyse feststelle, dass Sie bereits alles unter Kontrolle haben, gebe ich es ihnen genauso wieder, aber wenn ich große Verbesserungen sehe, erkläre ich ihnen wo diese zu finden sind und dann dürfen Sie selbst entscheiden.',
    q5: 'Ich habe nur Fremdware (Buybox).',
    a5: 'Ob Buybox-Ware oder Eigenmarken, man muss heutzutage in jedem Fall Sichtbarkeit erreichen. Besonders, wenn man wie Sie einen hohen Buybox Anteil hat.',
    q6: 'Wie viel Zeit brauche ich als Amazon Seller monatlich, sobald ich starte?',
    a6: 'Zu Beginn der Zusammenarbeit planen wir ca. 1–2 Stunden für das Onboarding und die initiale Abstimmung ein. Danach benötigen Sie im laufenden Betrieb nur noch etwa 1 Stunde pro Monat – den Rest übernehmen wir.',
  },

  footer: {
    logoText: 'Fox Performance',
    copyright: 'Amazon PPC & Produktbilder',
    quickLinksTitle: 'Quick Links',
    quickLink_ppc: 'Amazon PPC',
    quickLink_images: 'Produktbilder',
    quickLink_portfolio: 'Portfolio',
    quickLink_references: 'Referenzen',
    quickLink_about: 'Über Uns',
    quickLink_faq: 'FAQ',
    supportTitle: 'Support',
    support_contact: 'Kontakt',
    support_booking: 'Termin buchen',
    support_linkedin: 'LinkedIn',
    support_instagram: 'Instagram',
    legalTitle: 'Rechtliches',
    legal_imprint: 'Impressum',
    legal_privacy: 'Datenschutz',
    legal_terms: 'AGB',
    legal_cookies: 'Cookie-Einstellungen',
  },

  portfolioPage: {
    backToHome: 'Zurück zur Startseite',
  },

  imageGallery: {
    label: 'Ausgewählte Projekte',
    title: 'Design',
    titleHighlight: 'Portfolio',
    imagesFrom: 'Bilder aus',
    projects: 'Projekten',
    filterAll: 'Alle',
    showAll: 'Alle Bilder anzeigen',
    loadMore: 'Mehr laden',
    moreImages: 'weitere',
    close: 'Close',
    imageAlt: 'Bild',
    categories: {
      alpinspirit: 'Outdoor & Sport',
      aquaone: 'Aquaristik',
      'bb-verpackungen': 'Verpackung',
      boomding: 'Elektronik',
      buxtrade: 'Food & Snacks',
      cartvelli: 'Küche',
      graefenhof: 'Tee & Kräuter',
      greenli: 'Küche & Haushalt',
      mcfilter: 'Haushalt',
      oswald: 'Food & Gewürze',
      papierdrachen: 'Basteln & DIY',
      yosana: 'Küche & Lifestyle',
    },
  },

  processPricing: {
    processLabel: 'So einfach geht\'s',
    processTitle: 'So funktioniert\'s',
    processSubtitle: 'In 3 Schritten zu deinen Produktbildern.',
    step1Number: 'Schritt 1',
    step1Title: 'Kurzes Briefing',
    step1Time: '5 Min',
    step1Text: 'Schick uns deine Produktfotos und den Amazon-Link. Wir analysieren die Rezensionen und legen los.',
    step1Feature1: 'Basisfotos deines Produkts',
    step1Feature2: 'Amazon-Link (deins oder Konkurrenz)',
    step1Feature3: 'Keine Fotos? Produkt einsenden',
    step1Link: 'Jetzt Briefing starten',
    step2Number: 'Schritt 2',
    step2Title: 'Wir erstellen deine Bilder',
    step2Badge: 'Schnelle Umsetzung',
    step2Text: 'Wir erstellen deine Bilder – basierend auf echten Rezensionen, conversion-optimiert.',
    step2Feature1: 'Main Image nach Amazon TOS',
    step2Feature2: 'Infografiken & Lifestyle',
    step2Feature3: 'Rezensionsbasiert',
    step3Number: 'Schritt 3',
    step3Title: 'Revision & Finalisierung',
    step3Badge: 'Fertig für Amazon',
    step3Text: 'Du bekommst deine Bilder, gibst Feedback – eine Revision ist inklusive, weitere gegen Aufpreis.',
    step3Feature1: 'Alle Formate (JPG, PNG)',
    step3Feature2: '1 Revision inklusive',
    step3Feature3: 'Weitere gegen Aufpreis',
    step3Feature4: 'Volle Nutzungsrechte inklusive',
    pricingLabel: 'Unsere Angebote',
    pricingHeadline: 'Starte kostenlos oder hol dir das',
    pricingHeadlineHighlight: 'komplette Paket',
    freeBadge: 'Kostenlos',
    freeTitle: 'A/B Test Image',
    freeSubtitle: 'Teste uns unverbindlich',
    freePrice: '0€',
    freePeriod: 'einmalig',
    freeDesc: 'Wir erstellen ein optimiertes Produktbild für deinen Amazon Account – komplett kostenlos. Vergleiche es mit deinem aktuellen Bild und sieh den Unterschied.',
    freeFeature1: '1 optimiertes Produktbild',
    freeFeature2: 'Basierend auf Rezensionsanalyse',
    freeFeature3: 'Perfekt für A/B Tests',
    freeFeature4: 'Unverbindlich & risikofrei',
    freeCta: 'Kostenloses Bild anfragen',
    paidBadge: 'Empfohlen',
    paidTitle: 'Bildpaket',
    paidSubtitle: 'Komplettes Listing-Set',
    paidPricePrefix: 'ab',
    paidPrice: '999€',
    paidPeriod: 'pro Produkt',
    paidDesc: 'Das komplette Paket für dein Amazon Listing: Alle Bilder die du brauchst – Main Image, Infografiken, Lifestyle-Shots und A+ Content.',
    paidFeature1: 'Bis zu 10 Produktbilder',
    paidFeature2: 'Main Image + Galerie',
    paidFeature3: 'Infografiken & Lifestyle',
    paidFeature4: 'A+ Content ready',
    paidFeature5: '1 Revisionsschleife inkl.',
    paidFeature6: 'Volle Nutzungsrechte',
    paidCta: 'Bildpaket anfragen',
  },

  guidePage: {
    back: 'Zurück zur Startseite',
    title: 'Lade dir deinen',
    titleHighlight: 'Low Bid Guide',
    titleEnd: 'runter',
    subtitle: 'Erfahre, wie du mit der richtigen Gebotsstrategie deine Amazon Ads profitabler machst – kostenlos und unverbindlich.',
    labelCompany: 'Unternehmen',
    labelName: 'Ihr Vor- & Nachname',
    labelEmail: 'Ihre E-Mail Adresse',
    labelPhone: 'Telefonnummer',
    placeholderCompany: 'Seller Syndicate GmbH',
    placeholderName: 'Max Mustermann',
    placeholderEmail: 'z.B. max@mustermann.de',
    placeholderPhone: 'z.B. 0176 1234 567',
    privacyText: 'Ich bestätige die',
    privacyLink: 'Datenschutzerklärung',
    privacyEnd: 'gelesen zu haben und akzeptiere sie.',
    submit: 'Low Bid Guide runterladen',
    submitting: 'Wird gesendet...',
    secureNote: 'Deine Daten sind bei uns sicher!',
    successTitle: 'Download kommt!',
    successText: 'Vielen Dank! Wir senden dir den Guide in Kürze per E-Mail zu.',
    successBack: 'Zurück zur Startseite',
    errorText: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  },

  mastermindPage: {
    guestLabel: 'Unser nächster Gast',
    back: 'Zurück zur Startseite',
    title: 'Bewerbung',
    titleBreak: true,
    titleHighlight: 'Seller Syndicate Mastermind',
    subtitle: 'Bewirb dich jetzt für unsere exklusive Mastermind-Gruppe und bringe dein Amazon Business auf das nächste Level.',
    labelCompany: 'Unternehmen',
    labelName: 'Ihr Vor- & Nachname',
    labelEmail: 'Ihre E-Mail Adresse',
    labelPhone: 'Telefonnummer',
    placeholderCompany: 'Seller Syndicate GmbH',
    placeholderName: 'Max Mustermann',
    placeholderEmail: 'z.B. max@mustermann.de',
    placeholderPhone: 'z.B. 0176 1234 567',
    privacyText: 'Ich bestätige die',
    privacyLink: 'Datenschutzerklärung',
    privacyEnd: 'gelesen zu haben und akzeptiere sie.',
    submit: 'Jetzt bewerben',
    submitting: 'Wird gesendet...',
    secureNote: 'Deine Daten sind bei uns sicher!',
    successTitle: 'Bewerbung erhalten!',
    successText: 'Vielen Dank für deine Bewerbung. Wir melden uns in Kürze bei dir.',
    successBack: 'Zurück zur Startseite',
    errorText: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  },

  common: {
    loading: 'Loading...',
  },
};

export default de;
